// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Package: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M0.93,0.25l-0.68,0l0.01,0.68c0,0.34,0,21.91,0,22.13v0.67h23.49V0.25H0.93z M10.55,1.6h2.68v3.2l-1.34-0.74L10.55,4.8V1.6z
	 M22.4,22.4H1.6c0-11.69,0-18.66,0-20.8h7.6v5.48l2.69-1.48l2.69,1.48V1.6h7.82V22.4z"/>
<polygon points="8.72,14.2 9.67,15.15 11.22,13.6 11.22,18.14 12.57,18.14 12.57,13.6 14.12,15.15 15.07,14.2 11.89,11.02 "/>
</svg>;
};

export default React.memo(Package);
